import { FC, HTMLAttributes, useState } from "react";
import { useStyles } from "./ProfileAchievement.styles";
import { AchievementCard } from "../AchievementCard";
import { Achievement } from "@onmo/graphql/graphql";
import { useParams } from "react-router-dom";
import { AchievementDetailDialog } from "../AchievementDetailDialog";
import { sortAchievementsByOrder } from "../../../models/achievement";

interface IProfileAchievementProps {
  achievements?: Achievement[];
}

export const ProfileAchievement: FC<
  HTMLAttributes<HTMLDivElement> & IProfileAchievementProps
> = (props) => {
  const classes = useStyles();
  const { achievements } = props;
  const { userId: userIdParam }: { userId?: string } = useParams();
  const [selectedAchievement, setSelectedAchievement] = useState<Achievement>();

  const onClickAchievement = (achievement: Achievement) => {
    if (userIdParam) return;
    setSelectedAchievement(achievement);
  };

  if (!achievements) return null;

  return (
    <div className={classes.root}>
      {selectedAchievement && (
        <AchievementDetailDialog
          achievement={selectedAchievement}
          open={!!selectedAchievement}
          onClose={() => setSelectedAchievement(undefined)}
        />
      )}
      {sortAchievementsByOrder(achievements).map(
        (achievementItem: Achievement) => {
          return (
            <AchievementCard
              key={achievementItem.id}
              achievement={achievementItem}
              onClick={() => onClickAchievement(achievementItem)}
            />
          );
        },
      )}
    </div>
  );
};
